import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { MatTabChangeEvent, MatTabsModule } from "@angular/material/tabs";
import { DatosAbiertosTesisService } from "../../../core/services/datos-abiertos-tesis.service";
import { FormsModule } from "@angular/forms";

declare var Highcharts: any;

@Component({
    selector: 'app-datos-tesis',
    standalone: true,
    imports: [CommonModule, MatTabsModule, FormsModule],
    templateUrl: './tesis.component.html',
    styleUrl: './tesis.component.scss'
  })
export class DatosTesisComponent implements OnInit {

    startYear = 1988;
    endYear = new Date().getFullYear();
    years = new Array();
    currentStartYear = 2000;
    currentEpoca = 11;
    currentEndYear = this.endYear;
    load = false;
    data: any;
    typeGraph = 1;
    tables = new Array();
    constructor(private datosAbiertosTesisService: DatosAbiertosTesisService){
        for (let i = this.startYear; i <= this.endYear; i++) {
            this.years.push(i);
        }
    }

    ngOnInit(): void {
        this.loadScripts();
    }

    tabActive(event: MatTabChangeEvent): void {
       if (event.index === 1 && this.load === false) {
            this.loadData();
            this.loadApi();
       }
    }

    onChangeStart(event: any):void {
        let tmp = event.target.value;
        if(tmp != this.currentStartYear && this.currentEndYear >= tmp) {
            this.currentStartYear = parseInt(tmp);
            this.loadData();
        }
    }

    onChangeEnd(event: any):void {
        let tmp = event.target.value;
        if(tmp != this.currentEndYear && this.currentStartYear <= tmp) {
            this.currentEndYear = parseInt(tmp);
            this.loadData();
        }
    }

    loadTablePrincipal(): void {
        const serie1 = this.data.series[0].data.sort((a: any, b: any) => b.anio - a.anio).map((a: any) => a.total);
        const serie2 = this.data.series[1].data.sort((a: any, b: any) => b.anio - a.anio).map((a: any) => a.total);
        Highcharts.chart('container', {
          title: {
              text: this.data.title
          },
          xAxis: {
              categories: this.data.categories,
          },
          yAxis: {
              title: {
                  text: this.data.yAxis
              }
          },
          tooltip: {
              crosshairs: false,
              shared: false
          },
          plotOptions: {
            series: {
                label: {
                    connectorAllowed: false
                }
            }
        },
          series: [{
              name: this.data.series[0].name,
              marker: {
                  symbol: 'square'
              },
              data: serie1,
      
          }, {
              name: this.data.series[1].name,
              marker: {
                  symbol: 'diamond'
              },
              data: serie2
          }],
          credits: {
            enabled: false
          }
        });
    }

    loadBarPrincipal(): void {
        const serie1 = this.data.series[0].data.sort((a: any, b: any) => b.anio - a.anio).map((a: any) => a.total);
        const serie2 = this.data.series[1].data.sort((a: any, b: any) => b.anio - a.anio).map((a: any) => a.total);
        Highcharts.chart('container', {
            chart: {
                type: 'column'
            },
        
            title: {
                text: this.data.title,
            },
        
            xAxis: {
                categories: this.data.categories
            },
            yAxis: {
                min: 0,
                title: {
                    text: this.data.yAxis
                },
            },
            tooltip: {
                format: '<b>{key}</b><br/>{series.name}: {y}<br/>' +
                    'Total: {point.stackTotal}'
            },
            plotOptions: {
                column: {
                    stacking: 'normal',
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            series: [
                { name: this.data.series[0].name, data: serie1 }
                , { name: this.data.series[1].name, data: serie2 }
            ]
        });
    }

    private loadScripts() {
      let highcharts = document.createElement('script');
      let labels = document.createElement('script');
      let exportData = document.createElement('script');
      let accessibility = document.createElement('script');
      let exporth = document.createElement('script');
  
      highcharts.src = "https://code.highcharts.com/highcharts.js";
      highcharts.id = "high"
      if (document.getElementById('high') == null){
        document.head.append(highcharts);
      }
      labels.src = "https://code.highcharts.com/modules/series-label.js";
      labels.id = "series";
      accessibility.src = "https://code.highcharts.com/modules/accessibility.js";
      accessibility.id = "access";
      exportData.src = "https://code.highcharts.com/modules/export-data.js";
      exportData.id = "export-data";
      exporth.src = "https://code.highcharts.com/modules/exporting.js";
      exporth.id = "export";
  
      const scripts = setTimeout(() => {
        if (document.getElementById('series') == null) document.head.append(labels);
        if (document.getElementById('export-data') == null) document.head.append(exportData);
        if (document.getElementById('access') == null) document.head.append(accessibility);
        if (document.getElementById('export') == null) document.head.append(exporth);
        clearTimeout(scripts);
      }, 500)
    }

    private loadData(): void {
        this.datosAbiertosTesisService.graphTesis(this.currentStartYear, this.currentEndYear).subscribe({
            next: (result) => {
                this.data = result;
                setTimeout(() => {
                    if (this.typeGraph === 1) {
                        this.loadTablePrincipal();
                    } else {
                        this.loadBarPrincipal();
                    }
                }, 200);
            },
            error: (error) => {
              console.log(error);
            },
            complete: () => {
                this.load = true;
            }
          });
    }

    private loadApi(): void {
        this.datosAbiertosTesisService
            .getApis().subscribe({
            next: (response: any[]) => {
                for(let index = 0; index < response.length; index++){
                    this.tables.push(
                        {
                            id: index,
                            data: {},
                            epoca: this.currentEpoca,
                            url: response[index].url,
                            typeTable: 1
                        });
                    this.getDataApi(this.currentEpoca, response[index].url, index, 1);
                };
            },
            error: (error) => {
                console.log(error);
            }
        });
    }
    
    getDataApi(epoca: number, api: string, index: number, type: number): void {
        this.datosAbiertosTesisService
            .getData(epoca, api).subscribe({
                next: (response: any[]) => {
                    this.tables[index].data = response;
                    if(type === 0){
                        setTimeout(() => {
                            this.loadBar(index);
                        }, 200);
                    }
                },
                error: (error) => {
                    console.log(error);
                }
            });

    }

    onChangeEpoca(value: number, index: number): void {
        this.getDataApi(value, this.tables[index].url, index, this.tables[index].typeTable);
    }

    onClickType(value: number, index: number): void {
        if (this.tables[index].typeTable !== value) {
            this.tables[index].typeTable = value;
            setTimeout(() => {
                this.loadBar(index);
            }, 200);
        }
    }

    loadBar(index: number): void {
        Highcharts.chart('container' + index, {
            chart: {
                type: 'column'
            },
            xAxis: {
                categories: this.tables[index].data.categories.slice(0, -1)
            },
            yAxis: {
                min: 0,
                title: {
                    text: this.tables[index].data.yAxis
                },
            },
            tooltip: {
                format: '<b>{key}</b><br>' +
                    'Total: {point.stackTotal}'
            },
            plotOptions: {
                column: {
                    stacking: 'normal',
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            series: [{ 
                name: this.tables[index].data.xAxis,
                colorByPoint: true,
                data: this.tables[index].data.data.slice(0, -1) }
            ]
        });
    }

    getTablePropertty(row: any): string[] {
        return Object.getOwnPropertyNames(row);
    }
}